// src/services/teralehtiService.js
import { db } from '../firebase';
import { doc, getDoc, collection, getDocs, setDoc, arrayUnion, arrayRemove } from 'firebase/firestore';

const PUZZLES = 'teralehti-puzzles';
// Remembered word placements, each a { words[] } doc: removed = bonus, main = main, banned = never shown.
const LISTS = ['removed', 'main', 'banned'];
const listRef = (name) => doc(db, 'teralehti-admin', name);

export const fetchTeralehtiPuzzles = async () => {
  const snapshot = await getDocs(collection(db, PUZZLES));
  const map = {};
  snapshot.docs.forEach(d => { map[d.id] = { id: d.id, ...d.data() }; });
  return map;
};

export const saveTeralehtiPuzzle = async ({ id, letters, center, words, bonusWords }) => {
  await setDoc(doc(db, PUZZLES, id), { id, letters, center, words, bonusWords });
};

export const saveBonusWords = async (id, bonusWords) => {
  await setDoc(doc(db, PUZZLES, id), { bonusWords }, { merge: true });
};

export const fetchWordLists = async () => {
  const snaps = await Promise.all(LISTS.map(name => getDoc(listRef(name))));
  return Object.fromEntries(LISTS.map((name, i) =>
    [name, new Set(snaps[i].exists() ? snaps[i].data().words || [] : [])]));
};

// changes = { [list]: { add: string[], remove: string[] } }
export const updateWordLists = async (changes) => {
  const writes = [];
  Object.entries(changes).forEach(([name, { add = [], remove = [] }]) => {
    if (add.length) writes.push(setDoc(listRef(name), { words: arrayUnion(...add) }, { merge: true }));
    if (remove.length) writes.push(setDoc(listRef(name), { words: arrayRemove(...remove) }, { merge: true }));
  });
  await Promise.all(writes);
};
